<template>
  <div>
    <issue-template ref="template" :type="type" @issue="issue"/>
    <vxe-loading v-model="loading"/>
  </div>
</template>
<script>
import { post } from '@/api/Api'
import api from '@/api'
import IssueTemplate from '@/views/outbound/issue/IssueTemplate.vue'

export default {
  components: { IssueTemplate },
  data() {
    return {
      loading: false,
      type: 'shortable'
    }
  },
  methods: {
    issue(orderId) {
      this.loading = true
      post(api.dispatchSubmit, {}, { id: orderId }).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.issueSuccess'))
          this.$refs.template.refresh()
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>